import { GithubIcon } from '@cycle-app/ui/icons';
import styled from 'styled-components';

export const StyledIcon = styled(GithubIcon)`
  color: ${p => p.theme.colors.text.primary};
  flex: none;
`;
